import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import CompanyLuggageSetting from './CompanyLuggageSettings'
import SelectCompany from './SelectCompany/SelectCompany'
import CargoSharing from './CargoSharing'

const MTPLMasterSetting = () => {
   const [searchParams] = useSearchParams()
  const [mtplMasterSettingOpt, setmtplMasterSettingOpt] = useState(Number(searchParams.get('id')) || '')
  useEffect(() => {
    setmtplMasterSettingOpt(Number(searchParams.get('id')))
  }, [searchParams])
  let acountingType
  switch (mtplMasterSettingOpt) {
    case 1: {
      acountingType = <CompanyLuggageSetting />
      break
    }
      case 2: {
        acountingType = <SelectCompany />
        break
    }
    case 3: {
      acountingType = <CargoSharing />
      break
    }
  }
  return acountingType
}

export default MTPLMasterSetting